import { render, staticRenderFns } from "./detail-edit.vue?vue&type=template&id=81c3c648&scoped=true&"
import script from "./detail-edit.vue?vue&type=script&lang=js&"
export * from "./detail-edit.vue?vue&type=script&lang=js&"
import style0 from "./detail-edit.vue?vue&type=style&index=0&id=81c3c648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c3c648",
  null
  
)

export default component.exports